import { render, staticRenderFns } from "./BalanceCard.html?vue&type=template&id=13a5ec5a&scoped=true&"
import script from "./BalanceCard.js?vue&type=script&lang=js&"
export * from "./BalanceCard.js?vue&type=script&lang=js&"
import style0 from "./BalanceCard.scss?vue&type=style&index=0&id=13a5ec5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a5ec5a",
  null
  
)

export default component.exports